import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  CREDIT_NOTE_LABEL,
  DEBIT_NOTE_LABEL,
  formatSignedBaht,
  hasNoteAmounts,
} from "../CreditDebitNote/reportFigures";

interface NoteCaptionsProps {
  /** ≤ 0: a credit note lowers the sale. Absent on a backend that predates the notes. */
  creditNoteAmount?: number;
  /** ≥ 0: a debit note raises it. */
  debitNoteAmount?: number;
  /** Decimals of the figure the captions sit beside. */
  decimals?: number;
}

/**
 * The ใบลดหนี้ / ใบเพิ่มหนี้ already netted into a dashboard sales figure, shown beside it so a
 * total that differs from the bills' adds up. A kind with no amount gets no line; with neither,
 * nothing is drawn.
 */
export default function NoteCaptions({
  creditNoteAmount = 0,
  debitNoteAmount = 0,
  decimals,
}: Readonly<NoteCaptionsProps>) {
  if (!hasNoteAmounts(creditNoteAmount, debitNoteAmount)) return null;

  return (
    <Stack>
      {creditNoteAmount !== 0 && (
        <Typography variant="caption" color="error">
          {`${CREDIT_NOTE_LABEL} ${formatSignedBaht(creditNoteAmount, decimals)}`}
        </Typography>
      )}
      {debitNoteAmount !== 0 && (
        <Typography variant="caption" color="text.secondary">
          {`${DEBIT_NOTE_LABEL} ${formatSignedBaht(debitNoteAmount, decimals)}`}
        </Typography>
      )}
    </Stack>
  );
}
